import * as angular from 'angular';
import { HasTruthyPropertyFilter } from 'app/_util/has-truthy-property.filter';

export interface LastBidFilter {
    /**
     * @ngdoc filter
     * @name pkpLastBid
     * @memberof app
     *
     * @description
     * Get the bid of the previous round, which defines the max bid of this round.
     *
     * * E.g if 0.1 -> get 0.0
     * * E.G if 1.0 -> get 0.0
     * * E.g if 0.2 -> get 0.1
     *
     * If previous round has no myRequestedQuantity get the round before that round.
     * If no previous round exists return null.
     *
     * @param {app.AuctionWindowDto[]} windows
     * @returns {app.QuantityDto|null} `null` if windows doesn't contain an active bid element,
     *  {@link app.AuctionWindowDto}'s `myRequestedQuantity`.
     *
     * @author flzemke.btc
     */
    (windows: AuctionWindowDto[], currentWindow: string): QuantityDto | null;
}

function lastBidFilter($filter: ng.IFilterService): LastBidFilter {
    return function (
        windows: AuctionWindowDto[],
        currentWindow: string
    ): QuantityDto | null {
        if (!windows || !windows.length) {
            return null;
        }

        let hasTruthyPropertyFilter: HasTruthyPropertyFilter =
            $filter<HasTruthyPropertyFilter>('pkpHasTruthyProperty');
        windows = hasTruthyPropertyFilter(windows, 'myRequestedQuantity');

        if (!windows.length) {
            return null;
        }

        let orderByFilter = $filter<ng.IFilterOrderBy>('orderBy');
        windows = orderByFilter(windows, 'roundNumber');

        let currentRound = parseFloat(currentWindow);
        let index = 0;
        while (
            index + 1 < windows.length &&
            parseFloat(windows[index + 1].roundNumber) < currentRound
        ) {
            index++;
        }

        return windows[index].myRequestedQuantity;
    };
}

angular.module('app').filter('pkpLastBid', lastBidFilter);
